export enum ListTypes {
  "Seletiva" = 0,
  "Integração" = 1,
  "Preenchimento" = 2,
}

export enum ListTypesTranslation {
  "selective" = 0,
  "integration" = 1,
  "filling" = 2,
}




// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/list-type.ts